import React, { useState, useEffect } from "react";
import { Card, Modal, Tooltip, Badge } from "antd";
import { FolderOpenOutlined } from "@ant-design/icons";
import { ProjectModalContent } from "./ProjectModalContent";
import { CATEGORY_COLORS } from "./colors"

export default function ProjectCard({ title, total, breakdown, color, dashboardData, modalProyectoTipo, setModalProyectoTipo }) {

    const [mainModalOpen, setMainModalOpen] = useState(false);
    const [itemModal, setItemModal] = useState(null);
    const showItemModal = (item) => setItemModal(item);

    useEffect(() => {
        if (!modalProyectoTipo) return;

        if (modalProyectoTipo === "Proyectos") {
            setMainModalOpen(true);
        } else {
            const item = breakdown.find((b) => b.type === modalProyectoTipo);
            if (item) setItemModal(item);
        }
    }, [modalProyectoTipo]);

    const closeMainModal = () => {
        setMainModalOpen(false);
        setModalProyectoTipo(null);
    };

    const closeItemModal = () => {
        setItemModal(null);
        setModalProyectoTipo(null);
    };

    return (
        <>
            <Card
                style={{ background: color, color: "#fff", borderRadius: 8 }}
                styles={{
                    header: { color: "#fff" },
                    body: { padding: 16 },
                }}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FolderOpenOutlined />
                        {title}
                    </span>
                }
            >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
                    <div
                        onClick={() => setMainModalOpen(true)}
                        style={{
                            textAlign: "center",
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            flexShrink: 0,
                        }}
                    >
                        <div
                            style={{
                                fontSize: 32,
                                fontWeight: "bold",
                                background: "rgba(255, 255, 255, 0.2)",
                                borderRadius: "50%",
                                width: 80,
                                height: 80,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "0 auto 8px",
                            }}
                        >
                            {total}
                        </div>
                        <div style={{ opacity: 0.9 }}>{title}</div>
                    </div>
                    <div style={{ flex: 1, marginLeft: 16 }}>
                        {breakdown.map((item, index) => {
                            const proyectos = dashboardData.proyectos[item.type] || [];
                            return (
                                <Tooltip
                                    key={index}
                                    title={
                                        <div>
                                            <strong>Proyectos {item.label}</strong>
                                            <div style={{ fontSize: 12 }}>
                                                {proyectos.slice(0, 3).map((p, idx) => (
                                                    <div key={idx}>• {p.split(" - ")[1]?.split(", ")[0]}</div>
                                                ))}
                                                {proyectos.length > 3 && <div style={{ opacity: 0.6 }}>... y más</div>}
                                            </div>
                                        </div>
                                    }
                                >
                                    <div
                                        onClick={() => showItemModal(item)}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            background: "rgba(255,255,255,0.2)",
                                            padding: "8px 16px",
                                            borderRadius: 999,
                                            marginBottom: 8,
                                            color: "#fff",
                                            cursor: "pointer",
                                            border: "1px solid rgba(255,255,255,0.3)",
                                        }}
                                    >
                                        <span style={{ fontWeight: 500 }}>{item.value}</span>
                                        <span>{item.label}</span>
                                    </div>
                                </Tooltip>
                            );
                        })}
                    </div>
                </div>
            </Card>
            <Modal
                open={mainModalOpen}
                onCancel={closeMainModal}
                footer={null}
                width={1000}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FolderOpenOutlined />
                        {`Todos los Proyectos (${total})`}
                    </span>
                }
                styles={{
                    body: {
                        maxHeight: "70vh",
                        overflowY: "auto",
                    },
                }}
            >
                <p>Lista completa de todos los proyectos organizados por categoría</p>
                <ProjectModalContent dashboardData={dashboardData} />
            </Modal>
            <Modal
                open={!!itemModal}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FolderOpenOutlined />
                        {`Proyectos - ${itemModal?.label}`}
                    </span>
                }
                onCancel={closeItemModal}
                footer={null}
                width={800}
                styles={{
                    body: {
                        maxHeight: "60vh",
                        overflowY: "auto",
                    },
                }}
            >
                <p>Lista completa de proyectos de {itemModal?.label}</p>
                {(dashboardData.proyectos[itemModal?.type] || []).map((proyecto, idx) => {
                    const colors = CATEGORY_COLORS[itemModal?.type];

                    return (
                        <Card
                            hoverable
                            key={idx}
                            style={{
                                marginBottom: 12,
                                borderLeft: `4px solid ${colors.borderColor}`,
                                backgroundColor: "#f9f9f9",
                                padding: 10,
                            }}
                        >
                            <div style={{ display: "flex", gap: 12 }}>
                                <Badge
                                    count={proyecto.split(" - ")[0]}
                                    style={{
                                        backgroundColor: colors.badgeBackground,
                                        color: "#fff",
                                        boxShadow: "0 0 0 1px #fff",
                                        marginTop: 4,
                                        fontSize: 13,
                                    }}
                                />
                                <div>
                                    <h6 style={{ margin: 0, color: colors.textColor }}>
                                        {proyecto.split(" - ")[1]?.split(", ")[0]}
                                    </h6>
                                    <div style={{ fontSize: 12, color: "#666" }}>
                                        📍 {proyecto.split(" - ")[1]?.split(", ").slice(1).join(", ")}
                                    </div>
                                </div>
                            </div>
                        </Card>
                    );
                })}
            </Modal>
        </>
    );
}
